import Token from "src/util/Token";

export const authReducerKey = "auth";
export const authInitialState = {
  user: null,
  isAuthenticated: !!Token.get("_flst"),
  accessToken: Token.get("_flst"),
};
